import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { IFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import AppPermissionsFilter from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppPermissionsFilter/AppPermissionsFilter";
import AppPermissionsFilterResult from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppPermissionsFilter/AppPermissionsFilterResult";
import type { AppsPermissionsDescriptionDto } from "app/pages/sales-intelligence/modules/find-apps-filters/types/description.dto";
import type { IAppsCommonFiltersDto, IAppsPermissionsFilter } from "app/pages/sales-intelligence/store/find-apps/types";

function createPermissionsFilter(
    permissionsDescription: AppsPermissionsDescriptionDto,
): IFilterInstance<IAppsCommonFiltersDto> {
    return {
        key: "permissions",
        trackingName: "App Permissions",
        title: { key: "si.find_apps.filters.permissions.title" },
        tooltipText: { key: "si.find_apps.filters.permissions.tooltip" },
        filter: new FilterPanelBaseFilter<IAppsPermissionsFilter, AppsPermissionsDescriptionDto>({
            options: permissionsDescription,
        }),
        filterView: AppPermissionsFilter,
        filterResultView: AppPermissionsFilterResult,
    };
}

export default createPermissionsFilter;
